import 'react-loading-skeleton/dist/skeleton.css'

import { Caption1, Flex, H5 } from '@components/atoms'
import { tiktokTrackEvent, trackEvent } from '@utils/tiktok'

import HomeInPlamListItem from '@components/molecules/box/HomeInPlamListItem'
import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

const HomeFanSpotList = ({ articleList = [], handleMoveDetail = () => {} }) => {
  const history = useHistory()

  const grouped = []
  for (let i = 0; i < articleList.length; i += 5) {
    grouped.push(articleList.slice(i, i + 5))
  }

  return (
    <Container type={'column'}>
      <Flex
        align={'center'}
        style={{ justifyContent: 'space-between', padding: '0 20px' }}
      >
        <H5 style={{ fontWeight: 500 }} type={'Bold'}>
          연예 핫이슈는 여기서
        </H5>
        <Flex
          align={'center'}
          justify={'center'}
          style={{
            background: '#f7f7f7',
            borderRadius: '100px',
            cursor: 'pointer',
            padding: '8px 12px',
          }}
          onClick={() => {
            if (window.ttp) {
              window.ttp.track('CustomEventTest', {
                page_name: 'home_fan_spot_list',
              })
            }

            tiktokTrackEvent('ViewContent', {})
            history.push('/fanspot')
          }}
        >
          <Caption1 color={'#646464'}>더보기</Caption1>
        </Flex>
      </Flex>
      <ScrollWrapper>
        {grouped.map((group, idx) => (
          <Column key={idx}>
            {group.map((item, i) => (
              <HomeInPlamListItem
                item={item}
                key={item._id}
                onClick={handleMoveDetail}
                index={idx * 5 + i}
              />
            ))}
          </Column>
        ))}
      </ScrollWrapper>
    </Container>
  )
}

export default HomeFanSpotList

const Container = styled(Flex)`
  gap: 16px;
`

const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 16px;
  padding: 0px 20px;

  scroll-snap-type: x mandatory;
  scroll-padding-left: 20px;
  scroll-behavior: smooth;
  scroll-snap-stop: always;

  &::-webkit-scrollbar {
    display: none;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex-shrink: 0;

  width: calc(100% - 7px);

  border-radius: 16px;
  border: 1px solid var(--grey-grey_30, #f4f4f4);
  background: var(--bg_white, #fff);
  padding: 24px 20px;
  scroll-snap-align: start;
  scroll-behavior: smooth;
  scroll-snap-stop: always;
  box-sizing: border-box;
`
